import { useState } from "react";
import { useAxios } from "../../../utils/useAxios";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";

/**
 * @typedef {Object} QuestType
 * @property {number} id - The quest ID
 * @property {string} title - The quest title
 * @property {string} status - The quest status
 * @property {number} total_episodes - The total episodes of the quest
 * @property {string} thumbnail_url - The thumbnail url of the quest
 */

/**
 * @typedef {Object.<string, QuestType[]>} GroupedQuests
 */

/**
 * Custom hook to handle fetching assigned quests grouped by category
 */
export const useGetQuestByCategory = () => {
    const [quests, setQuests] = useState(
    /** @type {GroupedQuests | null | undefined} */(undefined),
    );
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const { axiosInstance } = useAxios();

    /**
     * Fetch quests grouped by category
     * @async
     * @returns {Promise<void>}
     */
    const getQuestByCategory = async () => {
        try {
            setLoading(true);
            setError("");

            const url = `${TENANT_DOMAIN}/references/quests/grouped?type=all`;

            const response = await axiosInstance.get(url);

            setQuests(response.data?.data || null);
        } catch (err) {
            setQuests(null);
            if (err?.response?.status === 500) {
                setError(ERROR_MESSAGES.INTERNAL_SERVER);
            } else {
                setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
            }
        } finally {
            setLoading(false);
        }
    };

    return {
        quests,
        loading,
        error,
        getQuestByCategory,
    };
};
